<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">


          <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
            <h3>Build Accounts Lists that have no Contacts - {{ campaignDescription.campaign_name }}</h3>
          </vs-col>

         
        

      

       

          


          <!-- <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button :color="acceptButtonColor" type="filled"
              @click="acceptSelected">{{ accept_text }}</vs-button>


              <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            />
          </vs-col> -->
        </vs-row>
      </div>
    </vx-card>
    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

    <vx-card class="vxtable">

              <div v-if="showSalesDeveloperSubmit">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-1/6 w-full ml-5">
                <h6>Assign To :</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchDataAdministrators"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleDataAdmin"
                ></SalesDeveloperAutocomplete>
                <span class="text-danger text-sm">{{
                  please_choose_sales_developer
                }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click.prevent="updateDataAdminIds"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>


         <ClientDataGrid
              :key="companySDAccountComponentKey"
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="DataAdministratorClientSide"
              :columnDefs="accountColumnDefs"
              :rowData="accountRecords"
              :rowSelection="'single'"
            >
            </ClientDataGrid>


     
    </vx-card>


  </div>
</template>

<script>
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import _ from "lodash";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import Autocomplete from "@/components/autocomplete/Autocomplete.vue";
import vSelect from "vue-select";
import ProgressBar from 'vue-simple-progress'
 import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
export default {
  components: { Autocomplete, "v-select": vSelect , ProgressBar ,             flatPickr , ClientDataGrid,SalesDeveloperAutocomplete
},
  computed: {
    total_pages () {
      console.log("totla" , this.all_total)
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_accounts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
      selected_data_administrator_id: null,
            showSalesDeveloperSubmit: false,

            please_choose_sales_developer: null,

            companySDSearchComponentKey: 0,

         accountDataSource: [],
      accountRecords: [],
            accountColumnDefs: [],

            companySDAccountComponentKey:0,

                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_accounts : [],
      selected: [],
      allSelected: false,
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      accountDescription: {},
      addNewAccountsPopUp: false,
      campaignDescription: [],
      abilities: null,
      campaignId: null,
   
     
    };
  },
  mounted() {
      this.getCampaignDescription();
      this.getSDAccountColumns();
      this.getAccountDataSource();
 
  },
  watch: {
  
  
  },
  methods: {
    updateDataAdminIds() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.has_contacts_in_campaign_data_administrator_id = self.selected_data_administrator_id;
      data.campaign_id = self.campaignId;
      data.has_contacts_in_campaign_assigned_by = self.user_id;
      data.level = "account";

      if (self.selected_data_administrator_id == null) {
        self.please_choose_sales_developer =
          "Please select data manager to update";
      }


      console.log("data.table_ids", data.table_ids);

      self.$vs.loading();




      if (
        self.selected_data_administrator_id != null &&
        self.selected_table_ids.length != 0 &&
        self.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/updateHasContactsInCampaignDataAdministratorId", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.DataAdministratorClientSide.gridApi.deselectAll();
                 self.$refs.DataAdministratorClientSide.gridApi.refreshCells({force : true});
                self.getAccountDataSource();
                self.$vs.loading.close();

              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

      
    },
   getAccountDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.campaign_id = self.campaignId;
      data.user_id = self.user_id;
      self.$store
        .dispatch("accountsManagement/fetchAllAccountsThatHaveNoContactsForBuild", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);

       



          

          

          self.accountRecords = response_data;


          console.log("account Records" , self.accountRecords)

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
     getSDAccountColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumnsForDataBuild",
          self.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);

              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


            selected_columns.forEach(function(ele) {
          
              ele.headerName = ele.name;

              if (ele.column_id != "account_status" && ele.column_id != "account_status_notes") {
                  ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

              }else{
                ele.field = ele.column_id;
              }



                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns
          let actions = {
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            pinned: true,
            width: 50
          };

          this.accountColumnDefs.push(actions);











 



   

        

        })
        .catch(err => {
          console.log(err);
        });
    },
     sendSelectionToActualPage(items) {
      let selected_table_ids = [];

      items.forEach(element => {
        selected_table_ids.push(element.table_id);
      });

      this.selected_table_ids = selected_table_ids;
      this.showSalesDeveloperSubmit = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


// this.$vs.loading();






// let matches = this.unmatch_accounts;



var matches = [...this.unmatch_accounts, ...this.all_unmatched_accounts];



if (this.allSelected) {
  matches.forEach(match => {
    this.selected.pop({ id: match.id});
  });
} else {

  

  
  // this.allSelected = false;
  matches.forEach(match => {
    this.selected.push({ id: match.id });
  });
  // this.match_ten_context.map(
  //   function(ele) {
  //     if (ele.page == this.currentx) {
  //       return (ele.ten_selected = true);
  //     }
  //   }.bind(this)
  // );
}

this.selected = this.removeDuplicates(this.selected, "id");


// this.$vs.loading.close();

},
select() {
this.allSelected = false;

// this.match_ten_context.map(
//   function(ele) {
//     if (ele.page == this.currentx) {
//       return (ele.ten_selected = false);
//     }
//   }.bind(this)
// );
},


  
        handleDataAdmin() {
      this.selected_data_administrator_id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.please_choose_sales_developer = null;

      console.log("selected_data_administrator_id" , this.selected_data_administrator_id)
    },
       searchDataAdministrators(inputValue) {
      let data = {};
      data.search = inputValue;
      return this.$store
        .dispatch("elomarkUsersManagement/getDataAdministrators", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
  
   
    forceRerender() {
      this.componentKey += 1;
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
   
    goBack: function () {
      this.$router.push({ path: "/data_build/build_campaigns_with_accounts_that_have_no_contacts" });
    },
  
    finished() {
      this.selected = []
      this.allSelected = false
      location.reload()

      

    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/accounts/deduplicate_csv_accounts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/accounts/optionsAfterImportAccountToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

           
    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },

    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
        if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

  .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
</style>
